var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"create-task-upload"},[_c('el-upload',{ref:"upload",attrs:{"accept":".xls,.xlsx","show-file-list":false,"auto-upload":false,"on-change":_vm.onUploadChange,"action":"#"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }